// Localised messages for the error codes attached by `submitFormData`. Forms
// must never surface `error.message` to visitors — that string is English and
// technical ("Failed to fetch"), which tells them nothing about what to do next.
const SUBMISSION_ERROR_MESSAGES = {
  de: {
    network: "Die Verbindung zum Server konnte nicht hergestellt werden. Bitte prüfen Sie Ihre Internetverbindung – in Firmen- und Hochschulnetzen blockiert mitunter eine Firewall die Übertragung.",
    validation: "Die übermittelten Daten wurden abgelehnt. Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
    server: "Es gibt einen Übertragungsfehler. Bitte versuchen Sie es erneut.",
  },
  en: {
    network: "Could not reach the server. Please check your internet connection – corporate and university firewalls sometimes block the transmission.",
    validation: "The submitted data was rejected. Please check your entries and try again.",
    server: "There was a problem with your submission. Please try again.",
  },
};

const getSubmissionErrorMessage = (error, language, fallbackMessage) => {
  const messages = SUBMISSION_ERROR_MESSAGES[language] || SUBMISSION_ERROR_MESSAGES.de;
  return messages[error?.code] || fallbackMessage || messages.server;
};

const submitFormData = async (formData, endpoint) => {
  let response;

  try {
    response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
  } catch (cause) {
    // The request never reached the server: offline, DNS, or a firewall blocking
    // the backend's non-standard port. Distinct from a server-side rejection.
    console.error('Error submitting form data (request did not reach the server):', endpoint, cause);
    const error = new Error(`Network error while submitting to ${endpoint}: ${cause?.message}`);
    error.code = 'network';
    throw error;
  }

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    console.error('Error submitting form data:', response.status, body);
    const error = new Error(`Submission failed with status ${response.status}: ${body}`);
    error.code = response.status === 400 ? 'validation' : 'server';
    throw error;
  }

  // A 2xx means the submission landed — an unparseable body must not turn a
  // successful registration into an error dialog.
  return response.json().catch(() => ({}));
};

module.exports = {
  submitFormData,
  getSubmissionErrorMessage
};
